import React from 'react'
import '../styles/tailwind.css'
import LegalPage, { Callout, List, Section } from '../components/LegalPage'

const SyaratKetentuan = () => (
  <LegalPage title="Syarat &amp; Ketentuan" updatedAt="2 September 2026">
    <p className="mb-8 text-sm leading-relaxed text-[#53565D]">
      Dokumen ini mengatur penggunaan sistem administrasi keanggotaan The
      Jakmania. Sistem ini bukan layanan publik. Akses hanya diberikan kepada
      pengurus pusat dan koordinator wilayah yang ditunjuk. Dengan masuk ke
      sistem, Anda menyatakan telah membaca, memahami, dan terikat pada
      ketentuan di bawah ini.
    </p>

    <Section number="1" title="Ruang Lingkup">
      <p>
        Sistem ini digunakan untuk mengelola pendaftaran anggota, verifikasi
        oleh korwil, persetujuan pusat, penerbitan kartu tanda anggota, serta
        pengelolaan konten resmi organisasi.
      </p>
    </Section>

    <Section number="2" title="Akun dan Akses">
      <List
        items={[
          'Akun bersifat pribadi dan tidak boleh dipakai bersama. Satu akun untuk satu orang.',
          'Anda bertanggung jawab penuh atas seluruh aktivitas yang terjadi melalui akun Anda.',
          'Kata sandi tidak boleh dibagikan, dicatat di tempat yang dapat diakses orang lain, atau disimpan di perangkat bersama.',
          'Hak akses mengikuti peran Anda. Korwil hanya dapat melihat data wilayah yang menjadi tanggung jawabnya.',
          'Segera laporkan kepada pengurus pusat apabila Anda menduga akun Anda diakses pihak lain.',
        ]}
      />
    </Section>

    <Section number="3" title="Kewajiban Pengguna">
      <List
        items={[
          'Mengakses data hanya sepanjang diperlukan untuk menjalankan tugas keanggotaan.',
          'Menjaga kerahasiaan seluruh data pribadi anggota dan pendaftar yang Anda lihat melalui sistem ini.',
          'Memastikan data yang Anda masukkan atau verifikasi adalah benar dan sesuai dokumen pendukung.',
          'Menggunakan perangkat yang aman, serta keluar dari sistem setelah selesai bekerja, terutama pada perangkat bersama.',
        ]}
      />
    </Section>

    <Section number="4" title="Larangan">
      <p>Anda dilarang melakukan hal berikut:</p>
      <List
        items={[
          'Mengunduh, menyalin, memotret, atau membuat cadangan data anggota untuk keperluan di luar tugas organisasi.',
          'Membagikan data anggota kepada pihak ketiga tanpa dasar hukum dan tanpa persetujuan tertulis dari pengurus pusat.',
          'Menggunakan data anggota untuk kepentingan pribadi, komersial, politik, atau kampanye apa pun.',
          'Mengubah, menghapus, atau memanipulasi data tanpa kewenangan.',
          'Mencoba mengakses bagian sistem yang berada di luar hak akses Anda.',
        ]}
      />
    </Section>

    <Callout title="Pengingat: Undang-Undang Perlindungan Data Pribadi">
      <p>
        Data pendaftar yang Anda akses melalui sistem ini, termasuk Nomor Induk
        Kependudukan, alamat, nomor telepon, dan foto kartu identitas,
        merupakan data pribadi yang dilindungi Undang-Undang Nomor 27 Tahun
        2022 tentang Perlindungan Data Pribadi.
      </p>
      <p>
        Undang-undang tersebut mengatur sanksi pidana bagi setiap orang yang
        secara melawan hukum memperoleh, mengungkapkan, atau menggunakan data
        pribadi yang bukan miliknya. Sanksi tersebut dapat berupa pidana
        penjara dan denda dengan nilai yang sangat besar. Penyalahgunaan akses
        bukan sekadar pelanggaran aturan internal, melainkan dapat berujung
        pada proses hukum terhadap Anda secara pribadi.
      </p>
    </Callout>

    <Section number="5" title="Ketersediaan Layanan">
      <p>
        Sistem dapat mengalami gangguan, pemeliharaan terjadwal, atau perubahan
        fitur sewaktu-waktu. Pengurus akan mengupayakan pemberitahuan lebih
        awal apabila memungkinkan, namun tidak menjamin layanan tersedia tanpa
        henti.
      </p>
    </Section>

    <Section number="6" title="Sanksi">
      <p>
        Pelanggaran terhadap ketentuan ini dapat berakibat pada pencabutan hak
        akses, sanksi organisasi sesuai anggaran dasar dan anggaran rumah
        tangga, serta pelaporan kepada aparat penegak hukum apabila pelanggaran
        tersebut memenuhi unsur pidana.
      </p>
    </Section>

    <Section number="7" title="Perubahan Ketentuan">
      <p>
        Ketentuan ini dapat diperbarui sewaktu-waktu. Versi terbaru berlaku
        sejak dipublikasikan pada halaman ini. Anda dianggap menyetujui
        perubahan tersebut apabila tetap menggunakan sistem setelah pembaruan
        dilakukan.
      </p>
    </Section>

    <Section number="8" title="Kontak">
      <p>
        Pertanyaan mengenai ketentuan ini dapat disampaikan kepada pengurus
        pusat The Jakmania melalui kanal resmi organisasi.
      </p>
    </Section>
  </LegalPage>
)

export default SyaratKetentuan
